export default __webpack_public_path__ + "static/media/soocaawiHeader.80a836f2.png";